import { render, staticRenderFns } from "./samecityScaninEdit.vue?vue&type=template&id=5f37931d&scoped=true"
import script from "./samecityScaninEdit.vue?vue&type=script&lang=js"
export * from "./samecityScaninEdit.vue?vue&type=script&lang=js"
import style0 from "./samecityScaninEdit.vue?vue&type=style&index=0&id=5f37931d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f37931d",
  null
  
)

export default component.exports